import type { Dict } from "../core.js";
import type { shopIntegrationCards as vi } from "../vi/shopIntegrationCards.js";

export const shopIntegrationCards: Dict<typeof vi> = {
  title: "bube-shop integration cards",
  subtitle:
    "Only cards enabled here appear on the « Integrations » page of EVERY bube-shop store. Disabling only stops new connections — existing store connections keep running.",
  loadFailed: "Could not load bube-shop integration cards.",
  saveFailed: "Could not change the integration card.",
  storageNotReady:
    "The bube-shop database has no `integration_apps.visible` column yet (migration PLAT-2026-107 not applied). All cards are hidden and cannot be enabled.",
  shown: "Shown",
  hidden: "Hidden",
  comingSoon: "Coming soon",
  defaultState: "default, never changed",
  changedAt: "changed {at}",
  changedBy: " by {by}",
  show: "Show to stores",
  hide: "Hide from stores",
  confirmShow: "Confirm SHOWING « {name} » to every store",
  confirmHide: "Confirm HIDING « {name} »",
  saving: "Saving…",
  cancel: "Cancel",
  readOnly: "You have read-only access. Toggling cards requires the owner role (`hq.integrations.write`).",
};
